
import React, { useState } from 'react'
import { ChevronDown, LogOut, Bell } from 'lucide-react'
import { Link } from '@tanstack/react-router'
import { User } from '../types/auth'
import { Z_INDEX } from '@/lib/constants/z-index'



interface UserMenuProps {
  user: User | null
  onLogout: () => void
}

export default function UserMenu({ user, onLogout }: UserMenuProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [imageError, setImageError] = useState(false)

  const photoURL = user?.employee?.personalInfo?.pictureUrl || user?.avatar
  const initials = user?.name ? user.name.charAt(0).toUpperCase() : 'U'

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 sm:space-x-3 text-xs text-gray-300 hover:text-white transition-colors duration-200 group"
      >
        {photoURL && !imageError ? (
          <img
            src={photoURL}
            alt={user?.name || 'User'}
            className="w-9 h-9 rounded-full object-cover shadow-monumenta group-hover:shadow-monumenta-brand transition-all duration-200"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="w-9 h-9 bg-gradient-to-br from-brand-primary to-brand-accent-600 rounded-full flex items-center justify-center shadow-monumenta group-hover:shadow-monumenta-brand transition-all duration-200">
            <span className="text-xs font-bold text-brand-dark font-display">
              {initials}
            </span>
          </div>
        )}
        <span className="hidden sm:block truncate max-w-32 font-display font-medium">{user?.name}</span>
        <ChevronDown size={16} strokeWidth={1.5} className="hidden sm:block transition-transform duration-300 group-hover:scale-110" />
      </button>

      {isOpen && (
        <div
          className="absolute right-0 mt-2 w-48 bg-brand-dark-light/95 backdrop-blur-sm border border-gray-700/50 rounded-monumenta shadow-monumenta-xl animate-fade-in"
          style={{ zIndex: Z_INDEX.DROPDOWN }}
        >
          <div className="py-2">
            <Link
              to="/profile"
              className="block px-4 py-3 text-sm text-gray-300 hover:bg-brand-dark-lighter hover:text-brand-primary transition-all duration-200 font-body"
              onClick={() => setIsOpen(false)}
            >
              Meu Perfil
            </Link>
            <Link
              to="/notifications/preferences"
              className="block px-4 py-3 text-sm text-gray-300 hover:bg-brand-dark-lighter hover:text-brand-primary transition-all duration-200 font-body"
              onClick={() => setIsOpen(false)}
            >
              <div className="flex items-center">
                <Bell size={16} strokeWidth={1.5} className="mr-2" />
                Notificações
              </div>
            </Link>
            {user?.role === 'admin' && (
              <Link
                to="/settings"
                className="block px-4 py-3 text-sm text-gray-300 hover:bg-brand-dark-lighter hover:text-brand-primary transition-all duration-200 font-body"
                onClick={() => setIsOpen(false)}
              >
                Configurações
              </Link>
            )}
            <div className="border-t border-gray-700/50 my-1"></div>
            <button
              onClick={() => {
                setIsOpen(false)
                onLogout()
              }}
              className="block w-full text-left px-4 py-3 text-sm text-gray-300 hover:bg-brand-dark-lighter hover:text-brand-red transition-all duration-200"
            >
              <div className="flex items-center font-body">
                <LogOut size={16} strokeWidth={1.5} className="mr-2" />
                Sair
              </div>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}